import request from "@/utils/request";

export function getClientStatistics(data) {
  return request({
    url: "/c/user/getClientStatistics",
    method: "get",
    data,
  });
}
